import dynamic from 'next/dynamic';

export * from './sidebar';

const CalendarIcon = dynamic(() => import('./CalendarIcon'));
const CallIcon = dynamic(() => import('./CallIcon'));
const CarIcon = dynamic(() => import('./CarIcon'));
const CellphoneIcon = dynamic(() => import('./CellphoneIcon'));
const CertifiedIcon = dynamic(() => import('./CertifiedIcon'));
const CopyIcon = dynamic(() => import('./CopyIcon'));
const GlobeIcon = dynamic(() => import('./GlobeIcon'));
const InfoIcon = dynamic(() => import('./InfoIcon'));
const PlusIcon = dynamic(() => import('./PlusIcon'));
const ProfileIcon = dynamic(() => import('./ProfileIcon'));
const ToolsIcon = dynamic(() => import('./ToolsIcon'));
const FuelIcon = dynamic(() => import('./FuelIcon'));
const UmbrellaIcon = dynamic(() => import('./UmbrellaIcon'));
const KeyIcon = dynamic(() => import('./KeyIcon'));
const BankIcon = dynamic(() => import('./BankIcon'));
const EuroIcon = dynamic(() => import('./EuroIcon'));
const ClockIcon = dynamic(() => import('./ClockIcon'));
const DeleteIcon = dynamic(() => import('./DeleteIcon'));
const StatusIcon = dynamic(() => import('./StatusIcon'));
const OrderingIcon = dynamic(() => import('./OrderingIcon'));
const FileIcon = dynamic(() => import('./FileIcon'));
const EllipsisVerticalIcon = dynamic(() => import('./EllipsisVerticalIcon'));
const ColumnIcon = dynamic(() => import('./ColumnIcon'));
const ListIcon = dynamic(() => import('./ListIcon'));
const EditSquareIcon = dynamic(() => import('./EditSquareIcon'));
const EmailIcon = dynamic(() => import('./EmailIcon'));
const EmailThreadIcon = dynamic(() => import('./EmailThreadIcon'));
const UnassignedIcon = dynamic(() => import('./UnassignedIcon'));
const AssignedToMeIcon = dynamic(() => import('./AssignedToMeIcon'));
const RefreshIcon = dynamic(() => import('./RefreshIcon'));
const ClosedEmailIcon = dynamic(() => import('./ClosedEmailIcon'));
const OpenEmailIcon = dynamic(() => import('./OpenEmailIcon'));
const TeamIcon = dynamic(() => import('./TeamIcon'));
const StatusBlueIcon = dynamic(() => import('./StatusBlueIcon'));
const ProfileBlueIcon = dynamic(() => import('./ProfileBlueIcon'));
const ColumnUnsortedIcon = dynamic(() => import('./ColumnUnsortedIcon'));
const ColumnSortedAscendingIcon = dynamic(() =>
  import('./ColumnSortedAscendingIcon')
);
const ColumnSortedDescendingIcon = dynamic(() =>
  import('./ColumnSortedDescendingIcon')
);
const PendingIconStatus = dynamic(() => import('./PendingIconStatus'));
const ApprovedIconStatus = dynamic(() => import('./ApprovedIconStatus'));
const InProgressIconStatus = dynamic(() => import('./InProgressIconStatus'));
const AttachmentIcon = dynamic(() => import('./AttachmentIcon'));
const FailedIconStatus = dynamic(() => import('./FailedIconStatus'));
const DoubleArrow = dynamic(() => import('./DoubleArrow'));
const FlagIcon = dynamic(() => import('./FlagIcon'));
const UrgentPriorityIcon = dynamic(() => import('./UrgentPriorityIcon'));
const HighPriorityIcon = dynamic(() => import('./HighPriorityIcon'));
const MediumPriorityIcon = dynamic(() => import('./MediumPriorityIcon'));
const LowPriorityIcon = dynamic(() => import('./LowPriorityIcon'));
const ColumnSeparatorIcon = dynamic(() => import('./ColumnSeparatorIcon'));
const GridTimeRangeIcon = dynamic(() => import('./GridTimeRangeIcon'));
const FileCopyIcon = dynamic(() => import('./FileCopyIcon'));
const EditIcon = dynamic(() => import('./EditIcon'));

// Font Awesome Icons
const FACopyIcon = dynamic(() => import('./FontAwesome/FACopyIcon'));
const FAWarehouseIcon = dynamic(() => import('./FontAwesome/FAWarehouseIcon'));
const FABullseyeIcon = dynamic(() => import('./FontAwesome/FABullseyeIcon'));
const FACommentIcon = dynamic(() => import('./FontAwesome/FACommentIcon'));
const FAHistoryIcon = dynamic(() => import('./FontAwesome/FAHistoryIcon'));
const FAListCheckIcon = dynamic(() => import('./FontAwesome/FAListCheckIcon'));
const FACarIcon = dynamic(() => import('./FontAwesome/FACarIcon'));
const FAUserIcon = dynamic(() => import('./FontAwesome/FAUserIcon'));
const FADownloadIcon = dynamic(() => import('./FontAwesome/FADownloadIcon'));
const FACircleXMark = dynamic(() => import('./FontAwesome/FACircleXMark'));
const FAClock = dynamic(() => import('./FontAwesome/FAClock'));
const FACircleCheck = dynamic(() => import('./FontAwesome/FACircleCheck'));
const FAEuroIcon = dynamic(() => import('./FontAwesome/FAEuroIcon'));
const FACalendar = dynamic(() => import('./FontAwesome/FACalendar'));
const FAReloadIcon = dynamic(() => import('./FontAwesome/FAReloadIcon'));
const FAProductsIcon = dynamic(() => import('./FontAwesome/FAProductsIcon'));
const FAFileContractIcon = dynamic(() =>
  import('./FontAwesome/FAFileContractIcon')
);
const FAVehicleSales = dynamic(() => import('./FontAwesome/FAVehicleSales'));
const FAVehicleLeasing = dynamic(() =>
  import('./FontAwesome/FAVehicleLeasing')
);
const FADealership = dynamic(() => import('./FontAwesome/FADealership'));
const FAMaximiseIcon = dynamic(() => import('./FontAwesome/FAMaximiseIcon'));
const FATableIcon = dynamic(() => import('./FontAwesome/FATableIcon'));
const FAInfoIcon = dynamic(() => import('./FontAwesome/FAInfoIcon'));

export {
  CalendarIcon,
  CallIcon,
  CarIcon,
  CellphoneIcon,
  CertifiedIcon,
  CopyIcon,
  GlobeIcon,
  InfoIcon,
  PlusIcon,
  ProfileIcon,
  ToolsIcon,
  FuelIcon,
  UmbrellaIcon,
  KeyIcon,
  BankIcon,
  EuroIcon,
  ClockIcon,
  DeleteIcon,
  StatusIcon,
  OrderingIcon,
  FileIcon,
  EllipsisVerticalIcon,
  ListIcon,
  ColumnIcon,
  EditSquareIcon,
  EmailIcon,
  EmailThreadIcon,
  UnassignedIcon,
  AssignedToMeIcon,
  RefreshIcon,
  ClosedEmailIcon,
  OpenEmailIcon,
  TeamIcon,
  StatusBlueIcon,
  ProfileBlueIcon,
  ColumnUnsortedIcon,
  ColumnSortedAscendingIcon,
  ColumnSortedDescendingIcon,
  PendingIconStatus,
  ApprovedIconStatus,
  InProgressIconStatus,
  FailedIconStatus,
  AttachmentIcon,
  DoubleArrow,
  GridTimeRangeIcon,
  EditIcon,
  FACopyIcon,
  FAWarehouseIcon,
  FABullseyeIcon,
  FACommentIcon,
  FAHistoryIcon,
  FAListCheckIcon,
  FACarIcon,
  FAUserIcon,
  FADownloadIcon,
  FACircleXMark,
  FAClock,
  FACircleCheck,
  FAEuroIcon,
  FACalendar,
  FAReloadIcon,
  FAFileContractIcon,
  FAProductsIcon,
  FlagIcon,
  UrgentPriorityIcon,
  HighPriorityIcon,
  MediumPriorityIcon,
  LowPriorityIcon,
  ColumnSeparatorIcon,
  FAVehicleSales,
  FAVehicleLeasing,
  FADealership,
  FileCopyIcon,
  FAMaximiseIcon,
  FATableIcon,
  FAInfoIcon,
};
